import Vue from 'vue';
import store from '@/core/store';
import router from '@/core/routes';
import { mapValues } from 'lodash-es';
import eventbus from '@/core/shared/services/EventBus';
const DC_VERSION = '4.3.34';

if (window.sbvrenv.NODE_ENV !== 'production') {
  Vue.config.performance = true;
  Vue.config.devtools = true;

  eventbus.$on('interop', ({ type, name, payload }) => {
    let parsedPayload;
    try {
      parsedPayload = JSON.parse(payload);
    } catch (e) {
      parsedPayload = payload;
    }
    console.groupCollapsed(`interop ${type}: ${name}`);
    if (parsedPayload) console.log('JSON data: ', parsedPayload);
    console.log('Raw data: ', payload);
    console.groupEnd();
  });
  if (!window.sbvrenv.CEFSHARP) {
    const resolvedPromised = new Promise(resolve => {
      setTimeout(resolve, 1000);
    });
    window.CefSharp = {
      __mock: true,
      BindObjectAsync: () => {
        return resolvedPromised;
      },
    };
    (async function emulateInterop () {
      await resolvedPromised;
      window.interopToCEF = new Proxy(
        {},
        {
          get (target, name) {
            // if (name === 'getStationIdentity') return undefined
            return payload => {
              let returnedValue;
              let parsedPayload;
              try {
                parsedPayload = payload && JSON.parse(payload);
              } catch (e) {
                console.error(e);
              }
              const { type, id } = parsedPayload || {};
              const arrayToStore = [payload];
              const stored = JSON.parse(
                window.localStorage.getItem('_localdev_interop_sessions'),
              );
              switch (name) {
              // case 'startGame':
              //   returnedValue = new Promise(resolve => {
              //     const handler = () =>
              //       resolve(JSON.stringify({ result: 'Failed' }))
              //     setTimeout(handler, 20000)
              //   })
              //   break
              case 'cancelLaunch':
                returnedValue = Promise.reject(new Error());
                break;
              case 'getStationIdentity':
                returnedValue = Promise.resolve({
                  id: router.currentRoute.params.stationId,
                  token: store.state.auth.token,
                  version: DC_VERSION,
                });
                break;
              case 'startGame':
                returnedValue = new Promise(resolve => {
                  const handler = () =>
                    resolve(JSON.stringify({ result: 'Success' }));
                  setTimeout(handler, 200);
                });
                if (
                  store.state.launcher.appState &&
                    store.state.launcher.appState.runningId !== id
                ) {
                  returnedValue = Promise.resolve();
                  // if (type === 'launcher') {
                  setTimeout(() => {
                    window.interopToJS.appChanged(
                      JSON.stringify([
                        {
                          runningType: type,
                          type: type,
                          runningId: id,
                          game: {
                            id: id,
                            title: 'Game',
                          },
                          preset: null,
                          contentOwnership: null,
                          state: 'launching',
                        },
                      ]),
                    );
                  }, 2000);
                  setTimeout(() => {
                    window.interopToJS.appChanged(
                      JSON.stringify([
                        {
                          runningType: type,
                          type: type,
                          runningId: id,
                          game: {
                            id,
                            title: 'Game',
                          },
                          preset: null,
                          contentOwnership: null,
                          state: 'rendering',
                        },
                      ]),
                    );
                  }, 3000);
                  // }
                }
                break;
              case 'insertSession':
                if (stored) arrayToStore.unshift(...stored);
                console.log(parsedPayload, stored);
                window.localStorage.setItem(
                  '_localdev_interop_sessions',
                  JSON.stringify(arrayToStore),
                );
                break;
              case 'getAllSessions':
                returnedValue = JSON.parse(
                  window.localStorage.getItem('_localdev_interop_sessions'),
                );
                break;
              default:
                break;
              }
              return Promise.resolve(returnedValue);
            };
          },
        },
      );
      if (router.currentRoute.params.stationId) {
        window.interopToJS.appChanged(
          JSON.stringify([
            {
              runningType: 'launcher',
              runningId: 'b4373780-2877-11e8-a79e-1dccfb01cc0a',
              type: 'launcher',
              game: {
                id: 'b4373780-2877-11e8-a79e-1dccfb01cc0a',
                title: 'Launcher',
              },
              preset: null,
              contentOwnership: null,
            },
          ]),
        );
        setTimeout(() => {
          window.interopToJS.stationIdentityChanged(
            JSON.stringify({
              id: router.currentRoute.params.stationId,
              token: store.state.auth.token,
              version: DC_VERSION,
            }),
          );
          // window.interopToJS.appChanged(JSON.stringify([
          //   {
          //     'runningType': 'game',
          //     'runningId': '499f25b0-b927-11e7-8079-c7582fdae61c',
          //   },
          // ]))
        }, 100);
      }
    })();
  }

  store.subscribeAction(({ type, payload }) => {
    if (type === 'storeGameSessions') {
      console.group('session tracking:');

      const payloadFormatted = (payload instanceof Array
        ? payload
        : [payload]
      ).map(payload =>
        mapValues(payload, v =>
          typeof v === 'object' && v !== null ? v.id : v,
        ),
      );

      console.table(payloadFormatted);
      console.groupEnd();
    }
  });
}
